/* Personalisierte Punch Needle (Auftrag 018): Namensfeld prüfen und Live-Vorschau in Garn-Optik.
   Zwei getrennte Teile: (1) Prüfung des Namens – klein, läuft immer; (2) Vorschau – darf ausfallen, dann fehlt nur das
   Bild, der Kauf läuft weiter. Einstellungen je Produkt aus dem Metafeld personalisiert.einstellungen (Snippet
   personalisiert.liquid). Koordinaten im Mockup: Anteile 0–1 der Bildbreite/-höhe, Pixelmaße auf 1000 px Mockup.
   Auftrag 023: Initiale (Feld data-pz-art="initiale", Metafeld art = "initiale"): genau ein Buchstabe A–Z, die
   Vorschau legt das fertige Bild des Buchstabens (cfg.bilder) über das Produktbild statt Garn zu zeichnen. */
(function () {
  'use strict';

  var BASIS = 1000; // Mockup-Breite, auf die sich alle Pixelmaße beziehen
  var ZEICHEN = "A-Za-zÀ-ÖØ-öø-ÿĀ-ž"; // lateinische Buchstaben mit Akzenten (deckt die Schriften ab)
  var GUELTIG = new RegExp('^[' + ZEICHEN + "][" + ZEICHEN + "'’ \\-]*$");
  var VERBOTEN = new RegExp('[^' + ZEICHEN + "'’ \\-]", 'g');
  var INITIALE = /^[A-Z]$/;

  function laenge(text) { return Array.from ? Array.from(text).length : text.length; }

  // Schriftname im Metafeld (z. B. "pacifico") → @font-face-Familie aus personalisiert.liquid
  function familie(cfg) { return 'PZ ' + cfg.schrift; }

  /* ---------------------------------------------------------------- Teil 1: Prüfung */

  function Feld(wurzel) {
    this.wurzel = wurzel;
    this.eingabe = wurzel.querySelector('.pz-eingabe');
    this.druck = wurzel.querySelector('.pz-druck'); // Link zur Druckdatei (Auftrag 020), nur wenn das Metafeld ihn hat
    this.fehler = wurzel.querySelector('.pz-fehler');
    this.max = parseInt(this.eingabe.getAttribute('maxlength'), 10) || 10;
    this.initiale = this.eingabe.getAttribute('data-pz-art') === 'initiale';
    this.beobachter = [];
    var feld = this;
    this.eingabe.addEventListener('input', function () { feld.beimTippen(); });
    this.eingabe.addEventListener('blur', function () { feld.eingabe.value = feld.wert(); feld.melden(); });
    this.eingabe.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); feld.eingabe.blur(); } // Enter schließt nur die Tastatur
    });
  }

  Feld.prototype.formular = function () {
    return document.getElementById(this.eingabe.getAttribute('form'));
  };

  Feld.prototype.wert = function () {
    var w = this.eingabe.value.replace(/\s+/g, ' ').trim();
    return this.initiale ? w.toUpperCase() : w;
  };

  // Druckdatei-Link für den Lieferanten: Basis + Name wie getippt (zusammengefasste Leerzeichen, NFC) + .jpg
  Feld.prototype.druckSetzen = function () {
    if (!this.druck) return;
    var w = this.wert();
    if (w.normalize) w = w.normalize('NFC');
    this.druck.value = this.gueltig() ? this.druck.getAttribute('data-basis') + encodeURIComponent(w) + '.jpg' : '';
  };

  Feld.prototype.gueltig = function () {
    var w = this.wert();
    if (this.initiale) return INITIALE.test(w);
    return w !== '' && laenge(w) <= this.max && GUELTIG.test(w);
  };

  Feld.prototype.beimTippen = function () {
    var roh = this.eingabe.value;
    var sauber, falsch;
    if (this.initiale) { // „a“ wird still zu „A“; Ziffern, Umlaute, zweiter Buchstabe → Hinweis
      sauber = roh.replace(/[^A-Za-z]/g, '').slice(0, 1).toUpperCase();
      falsch = sauber !== roh.toUpperCase();
    } else {
      sauber = roh.replace(VERBOTEN, '').replace(/^\s+/, '').replace(/\s{2,}/g, ' ');
      falsch = sauber !== roh;
    }
    if (sauber !== roh) this.eingabe.value = sauber;
    if (falsch) {
      this.fehlerZeigen(this.fehler.getAttribute('data-zeichen'));
    } else if (!this.fehler.hidden) {
      this.fehlerAus();
    }
    this.druckSetzen();
    for (var i = 0; i < this.beobachter.length; i++) this.beobachter[i](this.wert());
  };

  Feld.prototype.fehlerZeigen = function (text) {
    this.fehler.textContent = text || this.fehler.getAttribute('data-pflicht');
    this.fehler.hidden = false;
    this.eingabe.setAttribute('aria-invalid', 'true');
  };

  Feld.prototype.fehlerAus = function () {
    this.fehler.hidden = true;
    this.eingabe.removeAttribute('aria-invalid');
  };

  Feld.prototype.melden = function () {
    if (this.gueltig()) { this.fehlerAus(); return true; }
    this.fehlerZeigen();
    return false;
  };

  var felder = [];

  // Vor allen anderen Skripten (Theme, Bundle-Apps) prüfen: Capture-Phase am Dokument.
  function sperren(e, formular) {
    for (var i = 0; i < felder.length; i++) {
      var f = felder[i];
      if (formular && f.formular() === formular && f.gueltig()) {
        f.eingabe.value = f.wert(); // so steht der Name in der Bestellung wie in der Druckdatei
        f.druckSetzen();
      }
      if (formular && f.formular() === formular && !f.gueltig()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        f.eingabe.value = f.wert();
        f.melden();
        f.eingabe.scrollIntoView({ block: 'center', behavior: 'smooth' });
        f.eingabe.focus({ preventScroll: true });
        return;
      }
    }
  }

  document.addEventListener('submit', function (e) { sperren(e, e.target); }, true);
  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('button, input[type="submit"]') : null;
    if (knopf && knopf.form && (knopf.type === 'submit' || knopf.getAttribute('name') === 'add')) {
      sperren(e, knopf.form);
    }
  }, true);

  /* ---------------------------------------------------------------- Teil 2: Vorschau */

  function leinwand(b, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.ceil(b));
    c.height = Math.max(1, Math.ceil(h));
    return c;
  }

  // Speicher sofort freigeben: iPhone-Safari hat ein knappes Limit für Zeichenflächen und räumt spät auf.
  function frei(c) { c.width = 0; c.height = 0; }

  // Unscharfe Kopie über den Schatten-Trick (ctx.filter fehlt in älteren Safari-Versionen).
  function unscharf(quelle, radius, farbe) {
    var c = leinwand(quelle.width, quelle.height);
    var x = c.getContext('2d');
    x.shadowColor = farbe || '#fff';
    x.shadowBlur = radius * 2;
    x.shadowOffsetX = quelle.width + 20;
    x.drawImage(quelle, -(quelle.width + 20), 0);
    return c;
  }

  // Gleiches Rauschen bei jedem Aufruf (sonst flimmert der Rand beim Tippen).
  function rauschen(b, h, s) {
    var zufall = 7;
    function naechste() { zufall = (zufall * 16807) % 2147483647; return zufall / 2147483647; }
    var schritt = 2.7 * s;
    var klein = leinwand(Math.ceil(b / schritt) + 2, Math.ceil(h / schritt) + 2);
    var kx = klein.getContext('2d');
    var bild = kx.createImageData(klein.width, klein.height);
    for (var i = 0; i < bild.data.length; i += 4) {
      var v = Math.round(naechste() * 255);
      bild.data[i] = bild.data[i + 1] = bild.data[i + 2] = v;
      bild.data[i + 3] = 255;
    }
    kx.putImageData(bild, 0, 0);
    var c = leinwand(b, h);
    var x = c.getContext('2d');
    x.imageSmoothingEnabled = true;
    x.drawImage(klein, 0, 0, klein.width * schritt, klein.height * schritt);
    var daten = x.getImageData(0, 0, c.width, c.height).data;
    frei(klein);
    frei(c);
    return daten;
  }

  function farbeHeller(hex, faktor) {
    var n = parseInt(hex.replace('#', ''), 16);
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    function k(v) { return Math.max(0, Math.min(255, Math.round(v * faktor))); }
    return 'rgb(' + k(r) + ',' + k(g) + ',' + k(b) + ')';
  }

  /* Name als Garn-Ebene zeichnen. s = Pixel je Mockup-Pixel. Ergebnis: Leinwand + Lage im Mockup-Maßstab s.
     Aufbau wie scripts/personalisiert_probe.py: Schrift + Verbreiterung, unruhiger Rand, Schlaufen-Struktur aus der
     Textur (Helligkeits-Details des Designs), Strichmitte heller/Rand dunkler, Licht oben links, Schlagschatten. */
  function garnEbene(name, cfg, s, textur) {
    var box = cfg.box;
    var einzel = laenge(name) === 1;
    var bw = box.b * BASIS * s, bh = box.h * BASIS * s;
    if (einzel) { bh *= cfg.monogramm || 1; }
    var lw = (cfg.verbreiterung || 5) * s; // Striche dicker: dünne Linien lassen sich nicht punchen
    var schrift = '"' + familie(cfg) + '"';

    var mess = (garnEbene.mess = garnEbene.mess || leinwand(10, 10).getContext('2d'));
    mess.font = '100px ' + schrift;
    var m = mess.measureText(name);
    var links = m.actualBoundingBoxLeft, rechts = m.actualBoundingBoxRight;
    var oben = m.actualBoundingBoxAscent, unten = m.actualBoundingBoxDescent;
    if (!(rechts + links > 0) || !(oben + unten > 0)) { links = 0; rechts = m.width; oben = 80; unten = 25; }
    var faktor = Math.min((bw - lw) / (links + rechts), (bh - lw) / (oben + unten));
    var groesse = 100 * faktor;
    var rand = Math.ceil(lw / 2 + 9 * s); // Platz für Schatten und Verbreiterung
    var B = Math.ceil((links + rechts) * faktor) + 2 * rand, H = Math.ceil((oben + unten) * faktor) + 2 * rand;
    var tx = rand + links * faktor, ty = rand + oben * faktor;

    // Maske: Schrift + Verbreiterung
    var maske = leinwand(B, H), mx = maske.getContext('2d');
    mx.font = groesse + 'px ' + schrift;
    mx.fillStyle = mx.strokeStyle = '#fff';
    mx.lineJoin = 'round';
    mx.lineWidth = lw;
    mx.fillText(name, tx, ty);
    mx.strokeText(name, tx, ty);

    // Rand leicht unruhig wie Garnschlaufen
    var unscharfe = unscharf(maske, 1.7 * s);
    var weich = unscharfe.getContext('2d').getImageData(0, 0, B, H);
    frei(unscharfe);
    var r = rauschen(B, H, s);
    var a = weich.data;
    for (var i = 3; i < a.length; i += 4) {
      var v = (a[i] + (r[i - 1] - 128) * 0.22 - 110) * 4;
      a[i] = v < 0 ? 0 : v > 255 ? 255 : v;
      a[i - 1] = a[i - 2] = a[i - 3] = 255;
    }
    mx.clearRect(0, 0, B, H);
    mx.putImageData(weich, 0, 0);

    // Garn: Grundfarbe, Schlaufen-Struktur, Wölbung
    var garn = leinwand(B, H), gx = garn.getContext('2d');
    gx.drawImage(maske, 0, 0);
    gx.globalCompositeOperation = 'source-in';
    gx.fillStyle = farbeHeller(cfg.farbe, 1.12);
    gx.fillRect(0, 0, B, H);
    var lageX = box.x * BASIS * s - B / 2, lageY = box.y * BASIS * s - H / 2;
    if (textur && cfg.textur_box) {
      var t = cfg.textur_box;
      gx.globalCompositeOperation = 'hard-light';
      gx.drawImage(textur, (t.x - t.b / 2) * BASIS * s - lageX, (t.y - t.h / 2) * BASIS * s - lageY,
        t.b * BASIS * s, t.h * BASIS * s);
      gx.globalCompositeOperation = 'destination-in';
      gx.drawImage(maske, 0, 0);
    }
    var aussen = leinwand(B, H), ax = aussen.getContext('2d');
    ax.fillStyle = farbeHeller(cfg.farbe, 0.4); // Kante dunkles Garn statt Schwarz
    ax.fillRect(0, 0, B, H);
    ax.globalCompositeOperation = 'destination-out';
    ax.drawImage(maske, 0, 0);
    gx.globalCompositeOperation = 'source-atop';
    [['rgba(0,0,0,0.40)', 4.5, 0, 0], ['rgba(0,0,0,0.30)', 2.5, -1.6, -1.6],
      ['rgba(255,255,255,0.30)', 2.5, 1.6, 1.6]].forEach(function (p) {
      gx.shadowColor = p[0];
      gx.shadowBlur = p[1] * 2 * s;
      gx.shadowOffsetX = p[2] * s;
      gx.shadowOffsetY = p[3] * s;
      gx.drawImage(aussen, 0, 0);
    });

    // Ergebnis: Schlagschatten auf dem Grund, darüber das Garn
    var ebene = leinwand(B, H), ex = ebene.getContext('2d');
    ex.shadowColor = 'rgba(55,35,20,0.38)';
    ex.shadowBlur = 3.5 * 2 * s;
    ex.shadowOffsetX = B + 20 + 2 * s;
    ex.shadowOffsetY = 2.7 * s;
    ex.drawImage(maske, -(B + 20), 0);
    ex.shadowColor = 'transparent';
    ex.drawImage(garn, 0, 0);
    frei(maske);
    frei(garn);
    frei(aussen);
    return { leinwand: ebene, x: lageX, y: lageY }; // Aufrufer gibt ebene nach dem Zeichnen frei
  }

  function bildLaden(url) {
    return new Promise(function (ok, fehler) {
      if (!url) { ok(null); return; }
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { ok(img); };
      img.onerror = function () { fehler(new Error('Bild fehlt: ' + url)); };
      img.src = url;
    });
  }

  function schriftLaden(familie, text) {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var laden = document.fonts.load('60px "' + familie + '"', text || 'Aa');
    var zeit = new Promise(function (_, fehler) { setTimeout(function () { fehler(new Error('Schrift lädt nicht')); }, 6000); });
    return Promise.race([laden, zeit]).then(function (gefunden) {
      if (gefunden && gefunden.length === 0) throw new Error('Schrift fehlt: ' + familie);
    });
  }

  /* Vorschau über dem Mockup in der Galerie (wandert beim Wischen mit dem Bild mit) und als Streifen unter dem Feld
     (am Handy sieht man beim Tippen das Hauptbild nicht). */
  function Vorschau(wurzel, feld, cfg) {
    this.wurzel = wurzel;
    this.cfg = cfg;
    this.feld = feld;
    this.name = '';
    this.textur = null;
    this.mockup = null;
    this.ueber = [];
    this.streifen = wurzel.querySelector('.pz-streifen');
    this.geplant = false;
  }

  Vorschau.prototype.start = function () {
    var v = this;
    var cfg = this.cfg;
    return Promise.all([
      schriftLaden(familie(cfg), cfg.beispiel),
      bildLaden(this.wurzel.getAttribute('data-pz-bild')),
      bildLaden(cfg.textur).catch(function () { return null; }) // ohne Textur: Garn ohne Schlaufen, aber da
    ]).then(function (teile) {
      v.mockup = teile[1];
      v.textur = teile[2];
      v.ueberlagerungen();
      v.feld.beobachter.push(function (name) { v.name = name; v.planen(); });
      v.name = v.feld.wert();
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { v.planen(); });
        v.ueber.forEach(function (u) { ro.observe(u.bild); });
        if (v.streifen) ro.observe(v.streifen);
      } else {
        window.addEventListener('resize', function () { v.planen(); });
      }
      if (v.streifen) v.streifen.hidden = false;
      v.zeichnen();
    });
  };

  Vorschau.prototype.ueberlagerungen = function () {
    var id = this.wurzel.getAttribute('data-pz-media');
    var v = this;
    document.querySelectorAll('[data-media-id="' + id + '"]').forEach(function (eintrag) {
      var bild = eintrag.querySelector('img');
      if (!bild || !bild.parentElement) return;
      var c = document.createElement('canvas');
      c.className = 'pz-ueber';
      c.setAttribute('aria-hidden', 'true');
      bild.parentElement.appendChild(c);
      v.ueber.push({ bild: bild, leinwand: c });
    });
  };

  Vorschau.prototype.planen = function () {
    var v = this;
    if (this.geplant) return;
    this.geplant = true;
    requestAnimationFrame(function () {
      v.geplant = false;
      try { v.zeichnen(); } catch (e) { v.aus(e); }
    });
  };

  Vorschau.prototype.text = function () {
    return this.name || this.cfg.beispiel || '';
  };

  Vorschau.prototype.zeichnen = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var name = this.text();
    var v = this;
    this.ueber.forEach(function (u) { v.ueberZeichnen(u, name, dpr); });
    if (this.streifen) this.streifenZeichnen(name, dpr);
  };

  // Lage des sichtbaren Bildes im img-Element (object-fit: contain) → Leinwand genau darüber (leer).
  function ueberLage(u, dpr) {
    var bild = u.bild, c = u.leinwand;
    var bb = bild.clientWidth, bh = bild.clientHeight;
    if (!bb || !bh) return null;
    var nb = bild.naturalWidth || bb, nh = bild.naturalHeight || bh;
    var mass = Math.min(bb / nb, bh / nh);
    var sb = nb * mass, sh = nh * mass;
    c.style.left = bild.offsetLeft + (bb - sb) / 2 + 'px';
    c.style.top = bild.offsetTop + (bh - sh) / 2 + 'px';
    c.style.width = sb + 'px';
    c.style.height = sh + 'px';
    var pb = Math.round(sb * dpr), ph = Math.round(sh * dpr);
    if (c.width !== pb || c.height !== ph) { c.width = pb; c.height = ph; }
    var x = c.getContext('2d');
    x.clearRect(0, 0, pb, ph);
    return { x: x, pb: pb, ph: ph };
  }

  Vorschau.prototype.ueberZeichnen = function (u, name, dpr) {
    var lage = ueberLage(u, dpr);
    if (!lage || !name) return;
    var x = lage.x, pb = lage.pb, ph = lage.ph;
    var t = this.cfg.textur_box;
    if (this.cfg.leer && this.mockup && t) {
      // Produktbild zeigt den Beispielnamen: Stelle mit dem Mockup ohne Namen abdecken
      var mb = this.mockup.naturalWidth, mh = this.mockup.naturalHeight;
      var l = Math.max(0, t.x - t.b / 2 - 0.01), o = Math.max(0, t.y - t.h / 2 - 0.01);
      var r = Math.min(1, t.x + t.b / 2 + 0.01), u = Math.min(1, t.y + t.h / 2 + 0.01);
      x.drawImage(this.mockup, l * mb, o * mh, (r - l) * mb, (u - o) * mh, l * pb, o * ph, (r - l) * pb, (u - o) * ph);
    }
    var s = pb / BASIS;
    var e = garnEbene(name, this.cfg, s, this.textur);
    x.drawImage(e.leinwand, e.x, e.y);
    frei(e.leinwand);
  };

  // Ausschnitt um das Textfeld, so breit wie das Formular.
  Vorschau.prototype.streifenZeichnen = function (name, dpr) {
    var c = this.streifen.querySelector('canvas');
    var breite = this.streifen.clientWidth;
    if (!breite || !this.mockup) return;
    var box = this.cfg.box, rand = this.cfg.streifen_rand || 0.07;
    var bb = box.b + 2 * rand, hoehe = Math.max(bb / 2.2, box.h * (this.cfg.monogramm || 1) + rand / 2);
    var aus = { x: box.x - bb / 2, y: box.y - hoehe / 2, b: bb, h: hoehe }; // flach, passt auch fürs Monogramm
    var cssH = breite * aus.h / aus.b;
    c.style.height = cssH + 'px';
    var pb = Math.round(breite * dpr), ph = Math.round(cssH * dpr);
    if (c.width !== pb || c.height !== ph) { c.width = pb; c.height = ph; }
    var x = c.getContext('2d');
    var s = pb / (aus.b * BASIS);
    var nb = this.mockup.naturalWidth, nh = this.mockup.naturalHeight;
    x.drawImage(this.mockup, aus.x * nb, aus.y * nh, aus.b * nb, aus.h * nh, 0, 0, pb, ph);
    if (!name) return;
    var e = garnEbene(name, this.cfg, s, this.textur);
    x.drawImage(e.leinwand, e.x - aus.x * BASIS * s, e.y - aus.y * BASIS * s);
    frei(e.leinwand);
  };

  /* Initiale (Auftrag 023): je Buchstabe ein fertiges Bild in derselben Lage wie das Produktbild. Ohne Eingabe zeigt
     das Produktbild das Beispiel; der Streifen zeigt den Ausschnitt um den Buchstaben (cfg.streifen_box). */
  function BildVorschau(wurzel, feld, cfg) {
    Vorschau.call(this, wurzel, feld, cfg);
    this.geladen = {};
    this.bild = null;
    this.bildFuer = '';
  }
  BildVorschau.prototype = Object.create(Vorschau.prototype);

  BildVorschau.prototype.start = function () {
    var v = this;
    this.ueberlagerungen();
    this.feld.beobachter.push(function (name) { v.name = name; v.laden().catch(function () {}); });
    this.name = this.feld.wert();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { v.planen(); });
      this.ueber.forEach(function (u) { ro.observe(u.bild); });
      if (this.streifen) ro.observe(this.streifen);
    } else {
      window.addEventListener('resize', function () { v.planen(); });
    }
    return this.laden().then(function () { if (v.streifen) v.streifen.hidden = false; v.planen(); });
  };

  // Bild des aktuellen Buchstabens (oder des Beispiels) laden; ein langsames älteres Bild überschreibt kein neueres.
  BildVorschau.prototype.laden = function () {
    var v = this, b = this.text().toUpperCase(), url = (this.cfg.bilder || {})[b];
    if (!url) { this.planen(); return Promise.resolve(); }
    if (!this.geladen[b]) this.geladen[b] = bildLaden(url);
    return this.geladen[b].then(function (img) {
      if (v.text().toUpperCase() !== b) return;
      v.bild = img;
      v.bildFuer = b;
      v.planen();
    }, function (e) { delete v.geladen[b]; throw e; });
  };

  BildVorschau.prototype.ueberZeichnen = function (u, name, dpr) {
    var lage = ueberLage(u, dpr);
    if (!lage || !name || !this.bild || this.bildFuer !== name.toUpperCase()) return;
    lage.x.drawImage(this.bild, 0, 0, lage.pb, lage.ph);
  };

  BildVorschau.prototype.streifenZeichnen = function (name, dpr) {
    var c = this.streifen.querySelector('canvas');
    var breite = this.streifen.clientWidth;
    if (!breite || !this.bild) return;
    var a = this.cfg.streifen_box || { x: 0.5, y: 0.53, b: 0.62, h: 0.4 };
    var cssH = breite * a.h / a.b;
    c.style.height = cssH + 'px';
    var pb = Math.round(breite * dpr), ph = Math.round(cssH * dpr);
    if (c.width !== pb || c.height !== ph) { c.width = pb; c.height = ph; }
    var nb = this.bild.naturalWidth, nh = this.bild.naturalHeight;
    c.getContext('2d').drawImage(this.bild, (a.x - a.b / 2) * nb, (a.y - a.h / 2) * nh, a.b * nb, a.h * nh, 0, 0, pb, ph);
  };

  Vorschau.prototype.aus = function (fehler) {
    this.ueber.forEach(function (u) { if (u.leinwand.parentElement) u.leinwand.parentElement.removeChild(u.leinwand); });
    this.ueber = [];
    if (this.streifen) this.streifen.hidden = true;
    if (window.console) console.warn('Personalisierung: Vorschau aus –', fehler && fehler.message);
  };

  /* ---------------------------------------------------------------- Start */

  function starten() {
    document.querySelectorAll('.pz').forEach(function (wurzel) {
      if (wurzel.getAttribute('data-pz-bereit')) return;
      wurzel.setAttribute('data-pz-bereit', '1');
      var feld;
      try {
        feld = new Feld(wurzel);
        feld.druckSetzen();
        felder.push(feld);
      } catch (e) {
        if (window.console) console.warn('Personalisierung: Feld –', e.message);
        return;
      }
      var vorschau;
      try {
        var cfg = JSON.parse(wurzel.querySelector('.pz-daten').textContent);
        if (cfg && cfg.art === 'initiale' && cfg.bilder) vorschau = new BildVorschau(wurzel, feld, cfg);
        else if (!cfg || !cfg.box || !cfg.schrift || !cfg.farbe) return;
        else vorschau = new Vorschau(wurzel, feld, cfg);
        vorschau.start().catch(function (e) { vorschau.aus(e); });
      } catch (e) {
        if (vorschau) vorschau.aus(e);
        else if (window.console) console.warn('Personalisierung: Vorschau aus –', e.message);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
})();
